import {map} from './array';

const
    trim = string => string.replace(/^\s+|\s+$/g, ''),

    title = (
        string => (
            map(string.split(' '),
                word => (
                    word &&
                    `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`))
            .join(' ')));

export {
    trim,
    title
};
